import { useEffect } from "react";
import { toast } from "react-hot-toast";
import { useAppDispatch, useAppSelector } from "@/redux/features/hooks";
import { setIsAuthenticated } from "@/redux/features/auth/auth.slice";
import Spinner from "@/components/Spinner";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ApiBaseUrl } from "@/redux/http";
import { useFetchCurrentUserAndRestaurant } from "@/hooks/auth/useFetchCurrentUserAndRestaurant";
import { logger } from "@/services/Logger";
import { getSecurityErrorMessage } from "@/lib/securityErrors";
import { getApiErrorMessage } from "@/lib/apiErrors";

const LoginCheck = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const user = searchParams.get("user");
  const expires = searchParams.get("expires");
  const hash = searchParams.get("hash");
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { fetchUserAndRestaurant } = useFetchCurrentUserAndRestaurant();

  const checkUser = async () => {
    const url = `${ApiBaseUrl}/login_link?user=${user}&expires=${expires}&hash=${hash}`;

    try {
      const res = await fetch(url, {
        credentials: "include",
      });

      if (res.ok) {
        dispatch(setIsAuthenticated(true));

        try {
          await fetchUserAndRestaurant();
          // Let the root route resolve the role-based landing page
          // (manager/owner → dashboard, cashier/waiter → hub, kitchen → kitchen).
          navigate("/");
        } catch (error) {
          logger.error("LoginCheck", "Error fetching user data:", error);
        }
      } else {
        const body = await res.json().catch(() => null);
        navigate("/auth/login");
        toast.error(
          getSecurityErrorMessage(body?.message) ??
            getApiErrorMessage(
              { status: res.status, data: body },
              "Une erreur est survenue"
            )
        );
      }
    } catch (error) {
      logger.error("LoginCheck", "Error fetching data:", error);
      throw error;
    }
  };

  useEffect(() => {
    if (user) {
      checkUser();
    } else if (isAuthenticated === true) {
      navigate("/");
    } else {
      navigate("/auth/login");
    }
  }, []);

  return (
    <main className="overflow-x-hidden bg-white">
      <div className="flex flex-col items-center justify-center h-screen gap-5">
        <Spinner />
        <p className="font-medium text-base xl:text-xl">
          Connexion en cours ...
        </p>
      </div>
    </main>
  );
};

export default LoginCheck;
